// extracted by mini-css-extract-plugin
export default {"container":"ModalMakeBooking_container__pPkv1","list":"ModalMakeBooking_list__oTOhI","avatar":"ModalMakeBooking_avatar__JPIVE","business":"ModalMakeBooking_business__hxwlB"};